import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as modelHelper from "../../../../helpers/modelHelper";

import Modal from "../../../global/generic/Modal";
import Table from "../../../global/generic/Table";
import CancelButton from "../../../global/generic/CancelButton";

class MasterProductsModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <Table
                className=" flex-child fill-flex-space"
                allowToggleSubRows={false}
                tableHeader={modelHelper.buildTableRow([
                    modelHelper.buildTableCell(<Translate value="general.productName" />)
                ])}
                tableRows={this.props.masterProductList.map((product) => {
                    return modelHelper.buildTableRow([modelHelper.buildTableCell(product.displayName)]);
                })}
                tableColumns={[modelHelper.buildTableColumn("col-6")]}
            />
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="customTab.siblingProducts" />)}
                content={this.getContent()}
                footer={modelHelper.buildModalSection(<CancelButton onClick={this.handleCloseModalClick} />)}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.customTab[ownProps.tabId] === undefined) {
        return {
            masterProductList: []
        };
    }

    return {
        masterProductList: store.customTab[ownProps.tabId].masterProductList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.MASTER_PRODUCTS_MODAL));
        }
    };
};

export default MasterProductsModal = connect(mapStoreToProps, mapDispatchToProps)(MasterProductsModal);
